export class ExceptionsTracker {
  track(_error: Error) { }
}
